/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Saved_Prompt_ExistsInputs */



/**
* | output |
* | --- |
* | "That prompt is already saved." |
*
* @param {Assistant_Saved_Prompt_ExistsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_saved_prompt_exists = /** @type {((inputs?: Assistant_Saved_Prompt_ExistsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Saved_Prompt_ExistsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cette invite est déjà enregistrée.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Eingabeaufforderung ist bereits gespeichert.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Questo prompt è già salvato.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Этот запрос уже сохранён.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Esa solicitud ya está guardada.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("该提示已保存。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このプロンプトはすでに保存されています。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("यह प्रॉम्प्ट पहले से सहेजा गया है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Esse prompt já está guardado.")
	return /** @type {LocalizedString} */ ("That prompt is already saved.")
});